import { useMemo, useCallback } from 'react';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI || '';

/**
 * Build the Google OAuth authorization URL for redirect flow.
 */
export function getGoogleAuthUrl(redirectTo?: string): string {
  if (!GOOGLE_CLIENT_ID || !GOOGLE_REDIRECT_URI) {
    return '';
  }
  const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
  url.searchParams.set('client_id', GOOGLE_CLIENT_ID);
  url.searchParams.set('redirect_uri', GOOGLE_REDIRECT_URI);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('scope', 'openid email profile');
  url.searchParams.set('access_type', 'online');
  url.searchParams.set('prompt', 'select_account');
  if (redirectTo && redirectTo.startsWith('/')) {
    url.searchParams.set('state', redirectTo);
  }
  return url.toString();
}

/**
 * Hook for Google OAuth redirect (login/signup). Returns URL and a handler
 * that redirects to Google or calls setError with notConfiguredMessage.
 */
export function useGoogleAuth(redirectTo?: string) {
  const googleAuthUrl = useMemo(
    () => getGoogleAuthUrl(redirectTo),
    [redirectTo]
  );

  const handleGoogleRedirect = useCallback(
    (setError: (message: string) => void, notConfiguredMessage: string) =>
      () => {
        if (!googleAuthUrl) {
          setError(notConfiguredMessage);
          return;
        }
        window.location.href = googleAuthUrl;
      },
    [googleAuthUrl]
  );

  return { googleAuthUrl, handleGoogleRedirect };
}
